import {QueryBuilder} from '@mui/icons-material';
import ArrMenu, {
  ArrMenuHandle,
  CustomMenuItem,
} from '../../../common/arr-menu/ArrMenu';
import React, {useCallback, useContext, useRef, useState} from 'react';
import {ArrAVPreviewContext} from '../arr-av-provider/ArrAVPreviewProvider';
import './ArrAudioWaveform.scss';
import {ArrAudioControlButton} from './ArrAudioControlButton';
import {t} from 'i18next';

const paybackItems: CustomMenuItem[] = [
  {id: '0.5', label: '0.5x'},
  {id: '1', label: '1x'},
  {id: '1.5', label: '1.5x'},
  {id: '2', label: '2x'},
  {id: '2.5', label: '2.5x'},
];

interface ArrAudioPaybackProps {
  onChangePayback?: (item?: CustomMenuItem) => void;
}

const ArrAudioPayback: React.FC<ArrAudioPaybackProps> = ({
  onChangePayback,
}: ArrAudioPaybackProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);
  const [selectedPayback, setSelectedPayback] = useState<CustomMenuItem>(
    paybackItems[1]
  );
  const menuRef1 = useRef<ArrMenuHandle | null>(null);

  const avPreviewcontext = useContext(ArrAVPreviewContext);
  const {setPlaybackRate} = avPreviewcontext;

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLElement>) => {
      setIsMenuOpen(!isMenuOpen);
      menuRef1.current?.open(e.currentTarget as HTMLElement);
    },
    [isMenuOpen]
  );

  const handleMenuItemClick = (item: CustomMenuItem) => {
    setSelectedPayback(item);
    onChangePayback?.(item);
    setPlaybackRate(Number.parseFloat(item.id));
  };

  return (
    <div data-testid="audio-payback" className="arr-audio-payback">
      <ArrAudioControlButton
        icon={<QueryBuilder />}
        toolTipText={t('docMedia.speed')}
        ariaLabel={t('docMedia.speed')}
        onClick={handleClick}
      />
      <ArrMenu
        id="arr-audio-menus"
        ref={menuRef1}
        items={paybackItems}
        selectedCustomMenuItem={selectedPayback}
        direction="top-right"
        className="arr-audio-payback"
        onClose={() => setIsMenuOpen(false)}
        onItemClick={(item) => handleMenuItemClick(item)}
      />
    </div>
  );
};

export {ArrAudioPayback};
